<app-loader></app-loader>
<app-message></app-message>
<p-confirmDialog
    [acceptButtonStyleClass]="'dialog-button'"
    [rejectButtonStyleClass]="'dialog-button'"
    icon="pi pi-exclamation-triangle">
</p-confirmDialog>
<app-container *ngIf="token && filename"></app-container>
<h1 *ngIf="!token" class="auth-error">
    Errore durante l'autenticazione: token mancante o non valido!
</h1>

<h1 *ngIf="!filename" class="auth-error">
    Errore durante il caricamento dell'applicazione: planimetria mancante!
</h1>